<script>
//TODO: centralize location, time and canteen settings!
import Modal from '@/components/atoms/Modal'
import Step0 from '@/components/organism/location/editLocation/Step0'
import Step1 from '@/components/organism/location/editLocation/Step1'
import Step2 from '@/components/organism/location/editLocation/Step2'
import Step3 from '@/components/organism/location/editLocation/Step3'
import Step4 from '@/components/organism/location/editLocation/Step4'
import Step5 from '@/components/organism/location/editLocation/Step5'
import Step6 from '@/components/organism/location/editLocation/Step6'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import ModalConfirm from '@/components/organism/modal/ModalConfirm'
import slideTransitions from '@/modules/mixins/slideTransitions'
import Spinner from '@/components/atoms/Spinner'

import { mapGetters } from 'vuex'
import { Address } from '@/api'

export default {
    name: 'ModalEditLocation',

    components: {
        Modal,
        Step0,
        Step1,
        Step2,
        Step3,
        Step4,
        Step5,
        Step6,
        ButtonLoader,
        ModalConfirm,
        Spinner,
    },

    mixins: [slideTransitions],

    data() {
        return {
            address: {},
            backup: {},
            step: null,
            loading: false,
            showStepIndicator: 0,
        }
    },

    computed: {
        ...mapGetters({
            orderAddress: 'order/address',
        }),
        addressModel: {
            get() {
                return this.address.model || {}
            },
            set(address) {
                this.address.model = address
            },
        },
        title() {
            switch (this.step) {
                case 0:
                    return `${this.$t('base.edit')} ${this.address.name}`
                case 1:
                case 6:
                    return this.$t('details.specify_address')
                case 2:
                    return this.$t('details.edit_name_address')
                case 3:
                    return this.$t('details.confirm_address')
                case 4:
                    return this.$t('details.edit_phone_address')
                case 5:
                    return this.$t('details.edit_comment_address')
                default:
                    return this.$t('details.search_address')
            }
        },
        label() {
            switch (this.step) {
                case 0:
                    return null
                default:
                    return this.$t('base.save')
            }
        },
        scrollId() {
            return `editLocation-${this._uid}`
        },
        isCompanyAddress() {
            return this.address?.is_company_address
        },
    },

    methods: {
        clone(obj) {
            return JSON.parse(JSON.stringify(obj))
        },
        open(address) {
            this.step = 0
            this.address = new Address(address)
            if (!this.address.originalLatitude) {
                this.address.model.original_longitude = this.address.longitude
                this.address.model.original_latitude = this.address.latitude
            }
            this.backup = this.clone(this.address.model)
            this.$refs.ModalEditLocation.openModal()
        },
        async close() {
            this.$refs.ModalEditLocation.closeModal()
        },
        async nextStep(step) {
            await this.setSlideLeft()
            if (step === 3) this.showStepIndicator = 1
            else if (step === 6) this.showStepIndicator = 2
            else this.showStepIndicator = 0
            this.step = step
            if (!step) {
                this.address.save()
                this.backup = this.clone(this.address.model)
            }
        },
        verifyStep() {
            if (this.$refs[`step-${this.step}`].verifyStep)
                this.$refs[`step-${this.step}`].verifyStep()
        },
        async updateAddresses() {
            this.$addresses.fetch()
            if (this.address?.id && this.orderAddress?.id === this.address?.id)
                this.$location.select.set(this.address.model, false)
        },
        async back() {
            await this.setSlideRight()
            if (this.step === 6) this.showStepIndicator = 1
            else this.showStepIndicator = 0
            this.step = this.step === 6 ? 3 : 0
            this.addressModel = this.clone(this.backup)
        },
        async deleteLocation() {
            const address = new Address(this.address.model)
            await address.destroy()
            await this.$addresses.fetch()
            await this.$store.dispatch('canteen/getResidentialList', true)
            if (this.address.id === this.orderAddress?.id) {
                await this.$store.dispatch('order/resetAddress')
                this.$cart.calculate()
            }

            // TODO
            if (this.address.id === this.getId(this.activeCanteen?.address?.user_address)) {
                await this.$store.dispatch(
                    'active/setCanteen',
                    this.$store.getters['canteen/residentialList'].find(
                        (rc) => rc.id === this.activeCanteen.id
                    )
                )
                await this.$user.getExpenseRules()
            }
            return
        },
    },
}
</script>

<template lang="pug">
modal.edit-location(ref="ModalEditLocation" :closable="!step || loading" @close="updateAddresses" @closed="updateAddresses"  close-class="btn-white-primary top-fix-8 top-md-fix-16 transform-none" scroll)
    template(v-slot:header)
        transition(name="fade")
            spinner.loader(v-if="loading" size="20")
        transition(name="fade")
            button.btn.btn-white-primary.btn-icon.rounded-circle.position-absolute(@click="back" v-if="step")
                icon(icon="fa-solid fa-arrow-left" size="lg")
            modal-confirm.position-absolute(
                :action="deleteLocation"
                @closed="close"
                button-class="btn btn-white-danger btn-icon rounded-circle position-absolute"
                button-confirm-class="btn btn-danger"
                header-label="labels.confirm_delete_address"
                confirm-label="base.delete"
                v-else-if="!isCompanyAddress"
            )
                icon(icon="fa-solid fa-trash")
                
        transition(:name="slide")
            .step-indicator(v-if="showStepIndicator")
                span(v-for="index in 2" :class="{'fill-step': index <= showStepIndicator}")
        transition(:name="slide" mode="out-in")
            .modal-header-text.text-center.pt-8.px-9.w-100(:key="`step-title-${step}`") {{ title }}
    template(v-slot:body)
        transition(:name="slideAbsolute" mode="out-in")
            component.w-100(:is="`step-${step}`" v-model="addressModel" @next="nextStep" :scroll-id="scrollId" :ref="`step-${step}`" :key="`step-${step}`")
       
    template(v-slot:footer)
        transition(:name="slide")
            .p-5.w-100(v-if="step")
                button.btn.btn-primary.btn-block(@click="verifyStep") {{ label }}
      
</template>
<style scoped>
.edit-location >>> .loader {
    position: absolute;
    right: 26px;
    top: 26px;
    z-index: 1;
}
</style>
